import { styled, Typography, Box, Divider } from '@mui/material';

export const Section = styled('div')`
  width: 100%;
  position: relative;
  padding-left: 15px;
  padding-right: 15px;
`;

export const Wrapper = styled(Box)`
  width: 100%;
  max-width: 1091px;
  margin-left: auto;
  margin-right: auto;
`;

export const Col = styled(Box)`
  
  form{
    margin-top: 6px;

    @media (min-width: 768px){
      margin-top: 0;
    }
  }
`;

export const SectionHeading = styled(Typography)`
  font: 800 36px/1.167 'Playfair Display', 'Times New Roman', Times, serif;
  margin-bottom: 24px;

  @media (min-width: 992px){
    font-size: 40px;
  }
  @media (min-width: 992px){
    font-size: 48px;
  }
`;

export const Description = styled(Typography)`
  color: #C0C0C0;
  font-size: 16px;
  line-height: 1.5;

  @media (min-width: 768px){
    font-size: 20px;
  }
`;

export const Address = styled(Box)`
  font-size: 14px;
  line-height: 1.35;
  margin-top: 24px;

  @media (min-width: 768px){
    font-size: 16px;
  }
`;

export const AddressHeading = styled(Typography)`
  font-weight: 700;
  display: block;
  font-size: 14px;
  line-height: 1.35;

  @media (min-width: 768px){
    font-size: 16px;
  }
`;